import angular from 'angular';
import userAccountComponent from './userAccount.component';

let userAccountModule = angular.module('userAccount', []).component('userAccount', userAccountComponent);

export
default userAccountModule;


// WEBPACK FOOTER //
// ./app/components/userAccount/userAccount.js